import React, { useState } from 'react';
import { publicApi } from '../utils/api';

// Universal login at the bare domain (pkg15v2). Email + password → server
// returns one of: session (single-host collapse), handoff (redirect to the
// firm subdomain), or picker (choose among firms sharing the email).
const ROOT_DOMAIN = process.env.REACT_APP_ROOT_DOMAIN || 'lawmighty.com';

export default function UniversalLoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [picker, setPicker] = useState(null); // { pickerToken, options }

  // Persist the issued session token under the per-firm key, then send the
  // user into that firm's app.
  function landSession(token, subjectType, subdomain) {
    // Subdomain-scoped token name per the Lawmighty brief.
    const key = `lawmighty_token_${subdomain}`;
    try { localStorage.setItem(key, token); } catch (_) { /* ignore */ }
    const path = subjectType === 'admin' ? '/admin/dashboard' : '/';
    window.location.href = `https://${subdomain}.${ROOT_DOMAIN}${path}`;
  }

  function applyResult(r) {
    if (r.mode === 'session') {
      landSession(r.token, r.subjectType, r.firmSubdomain);
    } else if (r.mode === 'handoff') {
      // Redirect to the firm subdomain's handoff landing, which exchanges the
      // short-lived token for a real session on that origin.
      window.location.href = r.dest.url;
    } else if (r.mode === 'picker') {
      setPicker({ pickerToken: r.pickerToken, options: r.options });
    }
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const r = await publicApi.universalLogin(email.trim(), password);
      applyResult(r);
    } catch (err) {
      setError(err.message || 'Unable to sign in.');
      setLoading(false);
    }
  }

  async function choose(firmId) {
    setError(''); setLoading(true);
    try {
      const r = await publicApi.universalSelect(picker.pickerToken, firmId);
      applyResult(r);
    } catch (err) {
      setError(err.message || 'Unable to continue.');
      setLoading(false);
    }
  }

  return (
    <div className="login-page">
      <div className="login-box">
        <div className="login-brand"><h1>Sign in</h1><p>Lawmighty</p></div>
        {error && <div className="alert alert-error">{error}</div>}

        {!picker ? (
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Email</label>
              <input type="email" value={email} autoComplete="email" autoFocus
                onChange={(e) => setEmail(e.target.value)} required />
            </div>
            <div className="form-group">
              <label>Password</label>
              <input type="password" value={password} autoComplete="current-password"
                onChange={(e) => setPassword(e.target.value)} required />
            </div>
            <button type="submit" className="btn btn-primary btn-block" disabled={loading}>
              {loading ? <><span className="spinner" />Signing in…</> : 'Sign in'}
            </button>
          </form>
        ) : (
          <div>
            <p style={{ color: '#555', marginTop: 0 }}>You have access to more than one firm. Which one?</p>
            {picker.options.map((o) => (
              <button key={o.firm_id} className="btn btn-block" style={{ marginBottom: 8 }}
                disabled={loading} onClick={() => choose(o.firm_id)}>
                {o.firm_name} <span style={{ color: '#888' }}>({o.subdomain}.{ROOT_DOMAIN})</span>
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
